function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * TypeList holds registered resource factory callbacks
 */
var TypeList =
/*#__PURE__*/
function () {
  /**
   * Creates a TypeList instance
   * @param {resourceFactoryCallback} defaultFactory Default factory function
   */
  function TypeList(defaultFactory) {
    _classCallCheck(this, TypeList);

    this.root = {};
    this.defaultFactory = defaultFactory;
  }
  /**
   * Adds a resource factory callback to a pattern.
   * The pattern may use the following wild cards:
   * * The asterisk (*) matches any part at any level of the resource name.
   * * The greater than symbol (>) matches one or more parts at the end of a resource name, and must be the last part.
   * @param {string} pattern Pattern of the resource type.
   * @param {resourceFactoryCallback} factory Resource factory callback
   */


  _createClass(TypeList, [{
    key: "addFactory",
    value: function addFactory(pattern, factory) {
      var tokens = pattern.split('.');
      var l = this.root;
      var n;
      var sfwc = false;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var t = _step.value;
          var lt = t.length;

          if (!lt || sfwc) {
            throw new Error("Invalid pattern");
          }

          if (lt > 1) {
            if (l.nodes) {
              n = l.nodes[t] = l.nodes[t] || {};
            } else {
              l.nodes = {};
              n = l.nodes[t] = {};
            }
          } else {
            if (t[0] === '*') {
              n = l.pwc = l.pwc || {};
            } else if (t[0] === '>') {
              n = l.fwc = l.fwc || {};
              sfwc = true;
            } else if (l.nodes) {
              n = l.nodes[t] = l.nodes[t] || {};
            } else {
              l.nodes = {};
              n = l.nodes[t] = {};
            }
          }

          l = n;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (l.factory) {
        throw new Error("Pattern already registered");
      }

      l.factory = factory;
    }
    /**
     * Removes a resource factory callback.
     * @param {string} pattern Pattern of the resource type.
     * @returns {?resourceFactoryCallback} Factory callback or undefined if no callback is registered on the pattern
     */

  }, {
    key: "removeFactory",
    value: function removeFactory(pattern) {
      var tokens = pattern.split('.');
      var l = this.root;
      var n;
      var sfwc = false;
      var lt;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = tokens[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var t = _step2.value;
          n = null;
          lt = t.length;

          if (lt && !sfwc) {
            if (lt > 1) {
              if (l.nodes) {
                n = l.nodes[t];
              }
            } else {
              if (t[0] === '*') {
                n = l.pwc;
              } else if (t[0] === '>') {
                n = l.fwc;
                sfwc = true;
              } else if (l.nodes) {
                n = l.nodes[t];
              }
            }
          }

          if (!n) {
            return;
          }

          l = n;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var f = l.factory;
      delete l.factory;
      return f;
    }
    /**
     * Gets the factory callback that best matches the pattern.
     * Matching will give priority to text, then to *-wildcards, and last to >-wildcards.
     * @param {string} rid Resource ID
     * @returns {resourceFactoryCallback} Factory callback
     */

  }, {
    key: "getFactory",
    value: function getFactory(rid) {
      var tokens = rid.replace(/\?.*$/, '').split('.');
      return this._match(tokens, 0, this.root) || this.defaultFactory;
    }
  }, {
    key: "_match",
    value: function _match(ts, i, l) {
      var t = ts[i++];
      var c = 2;
      var n = l.nodes ? l.nodes[t] : undefined;

      while (c--) {
        if (n) {
          if (ts.length === i) {
            if (n.factory) {
              return n.factory;
            }
          } else {
            var f = this._match(ts, i, n);

            if (f) {
              return f;
            }
          }
        }

        n = l.pwc;
      }

      n = l.fwc;
      return n && n.factory;
    }
  }]);

  return TypeList;
}();

export default TypeList;